/**
 * @file 菜单管理
 * @author lixiaobin
 */

import { postWithJson } from 'library/utils/serviceUtil'

/**
 * 获取菜单列表
 */
export const systemMenu = (params = {}) => {
    return postWithJson('/menu/systemMenu.np', params)
}

/**
 * 给菜单分配权限
 * @param {string} params.menuCode
 * @param {array<string>} params.permissionCodes
 */
export const setMenuPermissions = (params = {}) => {
    return postWithJson('/menu/setMenuPermissions.np', params)
}

/**
 * 给菜单分配权限
 * @param {string} params.menuCode
 * @param {string} params.pCode
 * @param {string} params.name
 * @param {string} params.remark
 * @param {array<string>} params.permissionCodes
 */
export const add = (params = {}) => {
    return postWithJson('/menu/add.np', params)
}

/**
 * 给菜单分配权限
 * @param {string} params.menuCode
 */
export const getMenuPermissions = (params = {}) => {
    return postWithJson('/menu/getMenuPermissions.np', params)
}

/**
 * 给菜单分配权限
 * @param {string} params.menuCode
 */
export const permissionList = (params = {}) => {
    return postWithJson('/permission/list.np', params)
}
